// Small composite of three at-a-glance chips for the lead-list row,
// rendered next to the existing skip-trace ready dot:
//
//   † (deceased)      — red, when parties.deceased is true
//   ⚠ (needs review)  — amber, when parties.needs_review is true
//   ✓ (traced)        — green, when skip_traced_at is set AND neither
//                        of the above flags is on
//
// Untraced parties get nothing rendered — keeps the row visually
// quiet until the trace has run. The transient "in-flight" state
// during a bulk trace is owned by the LeadList component, not here.

interface Props {
  deceased: boolean;
  needsReview: boolean;
  skipTracedAt: string | null;
  className?: string;
  /** When set, the ⚠ chip becomes a clickable button that fires
   *  onReviewClick — opens the candidates modal on the lead list. */
  onReviewClick?: () => void;
}

export function SkipTraceOutcomeIndicators({ deceased, needsReview, skipTracedAt, className = '', onReviewClick }: Props) {
  if (deceased) {
    return (
      <span title="Deceased per Enformion death records — do not dial"
        aria-label="deceased"
        className={'text-red text-[11px] leading-none align-middle ' + className}>†</span>
    );
  }
  if (needsReview) {
    if (onReviewClick) {
      return (
        <button
          type="button"
          onClick={onReviewClick}
          tabIndex={-1}
          title="Multiple Enformion matches — click to review candidates and pick the right one"
          aria-label="needs review (click to pick a different candidate)"
          className={'text-amber text-[11px] leading-none align-middle hover:text-amber/80 cursor-pointer ' + className}
        >⚠</button>
      );
    }
    return (
      <span title="Multiple Enformion matches — eyeball before push"
        aria-label="needs review"
        className={'text-amber text-[11px] leading-none align-middle ' + className}>⚠</span>
    );
  }
  if (skipTracedAt) {
    const date = skipTracedAt.slice(0, 10);
    return (
      <span title={`Skip-traced ${date}`}
        aria-label="traced"
        className={'text-green text-[10px] leading-none align-middle ' + className}>✓</span>
    );
  }
  return null;
}
